import { ApprovedSign } from './ApprovedSign';
import { UnderReviewSign } from './UnderReviewSign';

interface LoanSignStatusProps {
    error?: boolean;
}

export const LoanSignStatus = ({ error }: LoanSignStatusProps) => {
    return error ? <UnderReviewSign /> : <ApprovedSign />;
};
